import React, { useContext } from 'react';
import { SalvProgressStepper, Step } from '@salvapp/ui-components';
import AlertStatusSetupContext from './AlertStatusSetupContext';

const AlertStatusSetupStepper = () => {
  const { progressStepper, generalSetup, screeningSetup, monitoringSetup } = useContext(AlertStatusSetupContext)!;

  const { steps, activeStep } = progressStepper;
  const { data: generalSetupData } = generalSetup;
  const { data: screeningSetupData } = screeningSetup;
  const { data: monitoringSetupData } = monitoringSetup;

  const Detail = (props: { header: string; singleDetail?: string; listDetail?: string[] }) => (
    <div className={'m-t-8'}>
      <div className={'text-xs'} style={{ color: 'var(--text-medium)' }}>
        {props.header}
      </div>
      {props.singleDetail && <div className={'text-s'}>{props.singleDetail}</div>}
      {props.listDetail && (
        <ul className={'text-s'}>
          {props.listDetail.map((detail) => (
            <li key={detail}>
              <span className={'m-x-8'}>•</span>
              {detail}
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  const GeneralSetupData = () => {
    const alertTypes: string[] = [];
    if (generalSetupData.alertType.isScreeningEnabled) {
      alertTypes.push('Screening');
    }
    if (generalSetupData.alertType.isMonitoringEnabled) {
      alertTypes.push('Monitoring');
    }
    if (generalSetupData.alertType.isBridgeEnabled) {
      alertTypes.push('Bridge');
    }
    const entityTypes: string[] = [];
    if (generalSetupData.entityType.isTransaction) {
      entityTypes.push('Transaction');
    }
    if (generalSetupData.entityType.isPerson) {
      entityTypes.push('Person');
    }
    return (
      <div>
        <Detail header={'Status name'} singleDetail={generalSetupData.name} />
        <Detail header={'Status code'} singleDetail={generalSetupData.code} />
        <Detail header={'Final status'} singleDetail={generalSetupData.isFinal ? 'Yes' : 'No'} />
        {generalSetupData.isTruePositive !== null && (
          <Detail header={'True Positive'} singleDetail={generalSetupData.isTruePositive ? 'Yes' : 'No'} />
        )}
        <Detail header={'Enable for'} listDetail={alertTypes} />
        <Detail header={'Entity type'} listDetail={entityTypes} />
      </div>
    );
  };

  const ScreeningSetupData = () => {
    const alertSubtypes: string[] = [];
    if (screeningSetupData.alertSubtype.isPep) {
      alertSubtypes.push('PEP / RCA');
    }
    if (screeningSetupData.alertSubtype.isSanctions) {
      alertSubtypes.push('Sanctions');
    }
    if (screeningSetupData.alertSubtype.isAdverseMedia) {
      alertSubtypes.push('Adverse media');
    }
    if (screeningSetupData.alertSubtype.isAdverseMediaEntities) {
      alertSubtypes.push('Adverse media entities');
    }

    alertSubtypes.push(
      ...screeningSetupData.alertSubtype.customLists
        .filter((customList) => customList.isEnabled)
        .map((customList) => customList.name)
    );

    return (
      <div>
        <Detail header={'Alert type'} listDetail={alertSubtypes} />
        <Detail header={'Goodlistable'} singleDetail={screeningSetupData.isGoodlistable ? 'Yes' : 'No'} />
      </div>
    );
  };

  const MonitoringSetupData = () => {
    const alertSubtypes: string[] = [];
    if (monitoringSetupData.alertSubtype.isOnline) {
      alertSubtypes.push('Real-time');
    }
    if (monitoringSetupData.alertSubtype.isOffline) {
      alertSubtypes.push('Post-event');
    }
    if (monitoringSetupData.alertSubtype.isPeriodic) {
      alertSubtypes.push('Periodic');
    }

    return (
      <div>
        <Detail header={'Alert type'} listDetail={alertSubtypes} />
      </div>
    );
  };

  return (
    <SalvProgressStepper steps={steps} activeStep={activeStep} navigable={false}>
      <Step header='General setup'>{generalSetup.isSubmitted && <GeneralSetupData />}</Step>
      <Step header='Screening setup'>{screeningSetup.isSubmitted && <ScreeningSetupData />}</Step>
      <Step header='Monitoring setup'>{monitoringSetup.isSubmitted && <MonitoringSetupData />}</Step>
      <Step header='Summary' />
    </SalvProgressStepper>
  );
};
export default AlertStatusSetupStepper;
